import { useOutletContext } from "react-router-dom";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import FaqAccordion from "../components/FaqAccordion";
import { t } from "../i18n";
import { staticPath, siteUrl } from "../data";

export default function HelpPage() {
  const { lang } = useOutletContext();
  const i = t[lang];
  const title = lang === "it" ? "Assistenza e FAQ noleggio auto | BoingCars" : "Car Rental Help & FAQ | BoingCars";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: i.help.faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
    url: siteUrl(staticPath(lang, "help")),
  };

  return (
    <>
      <SEO lang={lang} title={title} description={i.help.sub} pathEn={staticPath("en", "help")} pathIt={staticPath("it", "help")} jsonLd={jsonLd} />
      <section className="container-site py-16 md:py-24" data-testid="help-page">
        <div className="grid gap-12 lg:grid-cols-5">
          <Reveal className="lg:col-span-2">
            <h1 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">{i.help.title}</h1>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-muted-foreground md:text-base">{i.help.sub}</p>
          </Reveal>
          <Reveal className="lg:col-span-3" delay={0.1}>
            <FaqAccordion faqs={i.help.faqs} testIdPrefix="help-faq" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
